import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12.0002 18.424L5.99023 12.414L7.40423 10.999L12.0042 15.599L16.6042 10.999L18.0102 12.414L12.0012 18.424H12.0002ZM12.0002 13L5.99023 6.98901L7.40423 5.57501L12.0042 10.175L16.6042 5.57501L18.0102 6.98901L12.0012 12.999L12.0002 13Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ChevronDuoDown"
);
